(function () {
  'use strict';
  var allowedPages = new Set(['国内送料', '海外発送について', 'contact', 'veneer-sheet-application-guide']);
  var allowedProducts = new Set(['ch7wn-500g-木材接着剤-ツキ板アイロン貼り', 'ch7wn-1kg-木材接着剤-ツキ板アイロン貼り']);
  function localizedHref(raw, origin, root, language) {
    if (!raw || !/^https?:\/\/|^\//i.test(raw) || raw.startsWith('//')) return null;
    var target;
    try { target = new URL(raw, origin); } catch (error) { return null; }
    if (target.origin !== origin || target.username || target.password) return null;
    for (var key of target.searchParams.keys()) {
      if (/^(country|country_code|currency|currency_code|locale|locale_code|language|language_code|market|market_id)$/i.test(key)) return null;
    }
    var match = target.pathname.match(/^\/(?:([a-z]{2}(?:-[a-z]{2})?)\/)?(pages|products)\/([^/]+)\/?$/i);
    if (!match || (match[1] && match[1] !== language)) return null;
    var handle;
    try { handle = decodeURIComponent(match[3]); } catch (error) { return null; }
    if (!(match[2] === 'pages' ? allowedPages : allowedProducts).has(handle)) return null;
    var base = root === '/' ? '' : root.replace(/\/$/, '');
    if (base && !/^\/[a-z]{2}(?:-[a-z]{2})?$/i.test(base)) return null;
    return base + '/' + match[2] + '/' + match[3] + target.search + target.hash;
  }
  function apply(container) {
    var scopes = [];
    if (container.matches && container.matches('[data-mori-market-links]')) scopes.push(container);
    if (container.querySelectorAll) scopes.push.apply(scopes, container.querySelectorAll('[data-mori-market-links]'));
    scopes.forEach(function (scope) {
      var root = scope.getAttribute('data-mori-root');
      var language = scope.getAttribute('data-mori-language');
      if (!root || !language) return;
      scope.querySelectorAll('a[href]').forEach(function (anchor) {
        if (anchor.hasAttribute('hreflang') || anchor.hasAttribute('download') || anchor.hasAttribute('data-mori-keep-market')) return;
        var href = localizedHref(anchor.getAttribute('href'), window.location.origin, root, language);
        if (href !== null && href !== anchor.getAttribute('href')) anchor.setAttribute('href', href);
      });
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { localizedHref: localizedHref };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(document); }, { once: true });
    else apply(document);
    document.addEventListener('shopify:section:load', function (event) { apply(event.target); });
  }
})();
